export default __webpack_public_path__ + "static/small-4-94e4ebd879bd69051895d08d5246fea7.png";